import Pikaday from 'pikaday';
import { $win, $hero, $wrapper, getCurrentDevice } from './utils';

const format = 'DD  MMMM  YYYY';

const initBookingDatepicker = () => {
	const $datepickers = $('.js-bm-container');
	let isKeyboard = false;

	$datepickers.each((index, el) => {
		const $datepicker = $(el);
		const fieldStart = el.querySelector('.js-datepicker-start');
		const fieldEnd = el.querySelector('.js-datepicker-end');
		const containerStart = el.querySelector('.js-datepicker-container-start');
		const containerEnd = el.querySelector('.js-datepicker-container-end');
		const fieldDateIn = el.querySelector('.js-date-in');
		const fieldDateOut = el.querySelector('.js-date-out');
		const bookingMaskFormat = 'MM/DD/YYYY';

		let startDate, endDate;

		const options = {
			minDate: new Date(),
			numberOfMonths: 1,
			bound: true,
			format,
			firstDay: 1,
			i18n: {
				previousMonth : 'Previous Month',
				nextMonth     : 'Next Month',
				months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
				weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
				weekdaysShort: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
			}
		}

		const today = moment().format(format);
		const tomorrow = moment().add(1, 'days').format(format);

		$(fieldStart).val(today);
		$(fieldEnd).val(tomorrow);
		fieldDateIn.value = moment().format(bookingMaskFormat);
		fieldDateOut.value = moment().add(1, 'days').format(bookingMaskFormat);

		const updateStartDate = () => {
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endDate = moment(startDate).add('1','day')._d;
			endPicker.setMinDate(endDate);
			endPicker.setDate(endDate);
			startPicker.setEndRange(endDate);

			fieldDateIn.value = moment(startDate).format(bookingMaskFormat);
			fieldDateOut.value = moment(startDate).add(1, 'days').format(bookingMaskFormat);

			// if ( previewElStart ) {
			// 	previewElStart.textContent = moment(startDate).format('D MMM');
			// 	previewElStart.classList.remove('disabled');
			// 	previewElStart.classList.add('active');
			// 	previewElEnd.classList.add('active');
			// }
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);

			fieldDateOut.value = moment(endDate).format(bookingMaskFormat);

			// if ( previewElStart ) {
			// 	previewElEnd.textContent = moment(endDate).format(format);
			// 	$(previewElEnd).prev().addClass('active');
			// }
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			container: containerStart,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					startDate = this.getDate();
					updateStartDate();

					setTimeout(function() {
						const nextDate = moment(startDate).add(1, 'days');
						const selectedMonth = nextDate.month();
						const selectedYear = nextDate.year();

						$(fieldEnd).val(nextDate.format(format));

						// previewElEnd.textContent = nextDate.format(format);
						// $(previewElEnd).prev().addClass('active');
						endPicker.setEndRange(nextDate._d);

						endPicker.gotoMonth(selectedMonth);
						endPicker.gotoYear(selectedYear);

						$(fieldEnd).focus();
					}, 10);
				}
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			container: containerEnd,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					endDate = this.getDate();
					updateEndDate();
				}
			}
		});

		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();

		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			updateEndDate();
		}

		// $(fieldStart).add($(fieldEnd)).on('focusin', function(event) {
		// 	$(container).parent().addClass('active');
		// })
		// .on('focusout', function() {
		// 	$(container).parent().removeClass('active');
		// });

		$(fieldEnd).on('focusin', function() {
			if ( !endDate && isKeyboard ) {
				endDate = moment(startDate, format).add(1, 'days')._d;

				endPicker.setDate(endDate);

				updateEndDate();
			}
		});

		$(fieldStart).on('keydown', function(event) {
			const code = event.keyCode;
			const currentDate = startPicker.getDate() ? startPicker.getDate() : new Date();

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				startDate = updateDateByKeyboard(currentDate, code);

				if ( startPicker._o.maxDate && startDate.getTime() > startPicker._o.maxDate.getTime() ) {
					startDate = startPicker._o.maxDate;
				}

				// Prevent startDate from going to a date before the minDate
				if ( startDate.getTime() < startPicker._o.minDate ) {
					startDate = startPicker._o.minDate;
				}

				// Check if the endDate is the day after startDate
				const isEndDateNext = endDate ? endDate.getTime() == moment(startDate, format).add(1, 'days')._d.getTime() : false;

				if (isEndDateNext) {
					// If it is, re-set the startDate to the day before that
					startDate == moment(endDate, format).subtract(1, 'days')._d;

					setTimeout(function() {
						startPicker.setDate(startDate);
					}, 10);
				}

				updateStartDate();
			}
		});

		$(fieldEnd).on('keydown', function(event) {
			const code = event.keyCode;
			const currentDate = endPicker.getDate() ? endPicker.getDate() : endPicker._o.minDate;

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				endDate = updateDateByKeyboard(currentDate, code);

				if ( endPicker._o.minDate && endDate.getTime() < endPicker._o.minDate.getTime() ) {
					endDate = endPicker._o.minDate;
				}

				if ( startDate ) {
					// Prevent startDate from going over endDate
					if ( startDate.getTime() == endDate.getTime() ) {
						endDate = moment(endDate, format).add(1, 'days')._d;

						setTimeout(function() {
							$(fieldEnd).val(endDate);
						}, 10);
					}
				}

				// Check if the startDate is the day before endtDate
				const isStartDatePrev = startDate ? startDate.getTime() == moment(endDate, format).subtract(1, 'days')._d.getTime() : false;

				if (isStartDatePrev) {
					// If it is, re-set the startDate to the day before that
					endDate == moment(startDate, format).add(1, 'days')._d;

					setTimeout(function() {
						endPicker.setDate(endDate);
					}, 10);
				}

				updateEndDate();
			}
		});

		function updateDateByKeyboard(originalDate, code) {
			let date;

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				isKeyboard = true;
			}

			switch(code){
				case 37:
					date = moment(originalDate, format).subtract(1, 'days')._d;
					break;
				case 38:
					date = moment(originalDate, format).subtract(7, 'days')._d;
					break;
				case 39:
					date = moment(originalDate, format).add(1, 'days')._d;
					break;
				case 40:
					date = moment(originalDate, format).add(7, 'days')._d;
					break;
			}

			setTimeout(function() {
				isKeyboard = false;
			}, 20);

			return date;
		}
	});
}

const handleChildren = () => {
	const $input = $('.js-bm-children');
	const template = $('#childrenSelectTemplate').html();
	let currentCount = 0;
	const $container = $('#children-selects');

	$input.on('change', function() {
		const value = Number($(this).val());

		if (value > currentCount) {
			const $childSelect = $(template);
			const $select = $childSelect.find('select');

			console.log($childSelect);
			console.log($select);

			$select.attr('name', 'childrenAge' + currentCount)
			$select.niceSelect();
			$childSelect.find('.child-number').text(currentCount + 1);

			$container.append($childSelect);
		} else {
			const $lastSelect = $container.find('.qty').last();

			$lastSelect.remove();
		}

		$container.toggleClass('d-none', value == 0);

		currentCount = value;
	});
}

export default function bookingUI() {
	initBookingDatepicker();

	$('.booking-mask__field, .select select').on('input change', function() {
		const $this = $(this);
		const val = $this.val();

		$this.closest('.booking-mask__controls').toggleClass('filled', val.length > 0);
	});

	handleChildren();

	if ($hero.length === 0 || getCurrentDevice() !== 'desktop') {
		$wrapper.addClass('bm-stacked');
	} else {
		$win.on('scroll', function() {
			const scrollTop = $win.scrollTop();

			if ($hero.length) {
				if (scrollTop === 0) {
					$wrapper.find('.booking-mask__body').removeAttr('style')
				}

				$wrapper.toggleClass('bm-stacked', scrollTop > $hero.height());
			}
		});
	}

	$('.js-toggle-bm').on('click', function(event) {
		event.preventDefault();

		$('.booking-mask').toggleClass('active');
		$('body').toggleClass('bm-active');
	});
}
